import { Component, OnInit } from '@angular/core';
import {AuthService} from '../../../shared/services/auth.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {first} from 'rxjs/operators';
import {Uuid} from '../../../shared/interface/response/uuid';
import {HttpErrorResponse} from '@angular/common/http';
import {FormHelperService} from '../../../shared/services/form-helper.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-google-authenticator-dialog',
  templateUrl: './google-authenticator-dialog.component.html',
  styleUrls: ['./google-authenticator-dialog.component.scss']
})
export class GoogleAuthenticatorDialogComponent implements OnInit {

  qrCodeUrl?: string;
  gaForm: FormGroup;
  googleAuthenticatorCodeControl: FormControl;
  processingRequest = false;
  formErrors = {};
  gaEnabled = false;

  constructor(
    private auth: AuthService,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private snack: MatSnackBar,
    public dialogRef: MatDialogRef<GoogleAuthenticatorDialogComponent>,

  ) {
    this.gaForm = fb.group({
      code: this.googleAuthenticatorCodeControl = fb.control('', [Validators.required])
    });
  }

  ngOnInit(): void {
    this.auth.getGoogleAuthQrCode()
      .subscribe((response) => {
        this.qrCodeUrl = response.url;
      });
  }

  enableGoogleAuthenticator(): void {
    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.gaForm, this.formErrors);
    this.formErrors = {};

    this.auth.enableGoogleAuthenticator(this.gaForm.getRawValue())
      .pipe(
        first()
      )
      .subscribe(() => {
        this.snack.open('Pomyślnie skonfigurowano token', '', {
          duration: 5000,
        });
        this.processingRequest = false;
        this.gaEnabled = true;
        this.googleAuthenticatorCodeControl.disable();
        this.auth.loadProfile();
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas konfiguracji tokenu wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.gaForm, this.formErrors);
        }
      })
    ;
  }
}
